import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "highlight" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "highlight-copy btn",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Copy code"
}, " copy ", -1)
const _hoisted_4 = { class: "highlight-code" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("\r\n          ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("\r\n        ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("pre", {
          class: _normalizeClass(`language-${_ctx.lang}`),
          style: _normalizeStyle({ height: _ctx.getHeightInPixesls })
        }, [
          _createElementVNode("code", {
            class: _normalizeClass(`language-${_ctx.lang}`)
          }, [
            _hoisted_5,
            _renderSlot(_ctx.$slots, "default"),
            _hoisted_6
          ], 2)
        ], 6)
      ])
    ])
  ]))
}